import React from "react";
import { LuPhoneCall } from "react-icons/lu";

const Button = () => {

 return (
    <div className="flex items-center justify-center">
        <a href='tel:+918101463629' className="">
      <button
        className="relative flex items-center gap-2 px-4 py-2 w-[160px] text-[15px] font-semibold text-[#7EB9EC] rounded-full border-[3px] border-double border-[rgba(74,61,255,0.75)] bg-gradient-to-r from-[#0E0F3A] to-[#310376] transition-all duration-300  hover:border-[#642BD7] hover:shadow-md hover:text-[15px]"
      >
        <LuPhoneCall className="h-5 w-5 text-[#74C0FC]" />
        8101463629
      </button>
        </a>
    </div>
  );
};

export default Button;
